import React from 'react';
import { Input as AntInput } from 'antd';
import styled from 'styled-components';

const ExtendedInput = styled(AntInput)`
  &::placeholder {
    font-style: italic;
  }

  &.ant-input-disabled {
    border-color: var(--greyscale-dark-white);
    cursor: default;

    &::placeholder {
      color: var(--greyscale-concrete);
    }
  }
`;

ExtendedInput.Password = AntInput.Password;

export const Input = (props) => <ExtendedInput {...props} maxLength={props.maxLength || 100} />;
